// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {isNotEmpty} from '../../../claim/shared/services/claim-shared-helper';

const QuestionablePartButtonGroup = props => {

    const canExecuteReport = isNotEmpty(props.partNumber);

    return (
        <div className='questionable-part-button-group'>
            <button
                className='secondary-button'
                onClick={props.onCriteriaReset}
                type='submit'
            >
                <FormattedMessage id='RESET'/>
            </button>
            <button
                className='primary-button'
                disabled={!canExecuteReport}
                onClick={props.onPartSearchExecute}
                type='submit'
            >
                <FormattedMessage id='EXECUTE'/>
            </button>
        </div>
    );

};

QuestionablePartButtonGroup.displayName = 'QuestionablePartButtonGroup';
QuestionablePartButtonGroup.propTypes = {
    onCriteriaReset: PropTypes.func.isRequired,
    onPartSearchExecute: PropTypes.func.isRequired,
    partNumber: PropTypes.string.isRequired
};

export default QuestionablePartButtonGroup;



// WEBPACK FOOTER //
// ./src/reports/questionable-part-search/components/questionable-part-button-group.js